import * as React from 'react';

function SvgPadlockStroke1(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.992 10.625h1.238c.978 0 1.77.792 1.77 1.77v10.783a1.77 1.77 0 01-1.77 1.77H7.77A1.77 1.77 0 016 23.178V12.395c0-.978.792-1.77 1.77-1.77h1.238V8.808c.084-3.24 2.763-5.808 5.98-5.755 3.234-.053 5.91 2.504 6.004 5.759v1.813zm-1.457 0v-.877-.783-.132a4.458 4.458 0 00-4.547-4.323c-2.442-.04-4.46 1.895-4.523 4.317v1.798h9.07zm-12.078 1.77c0-.173.14-.313.313-.313h14.46c.172 0 .312.14.312.313v10.783c0 .172-.14.312-.312.312H7.77a.312.312 0 01-.313-.312V12.395zm10.033 4.097v-.013a2.535 2.535 0 00-4.131-1.926 1.357 1.357 0 00-.34.35c-.84 1.063-.658 2.653.433 3.525.013.011.029.047.029.084v1.684c0 .76.616 1.377 1.377 1.377h.27c.76 0 1.377-.616 1.377-1.377v-1.684c0-.034.017-.07.047-.094a2.461 2.461 0 00.938-1.926zm-3.385-.938c.423-.34.948-.405 1.394-.198.444.207.731.648.742 1.137-.004.37-.175.72-.467.948a1.382 1.382 0 00-.518 1.067v1.688c0 .07-.057.127-.128.127h-.27a.127.127 0 01-.128-.127v-1.684c0-.402-.175-.785-.481-1.046a1.298 1.298 0 01-.224-1.823.325.325 0 01.08-.09z"
        fill="white"
      />
    </svg>
  );
}

export default SvgPadlockStroke1;
